import styled from 'styled-components';

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  transition: 0.3s;

  flex: 1;
`;

export default Column;
